import { ColorEnum } from '@enum/style/color.enum';

import { TabStyleType } from './tabs-style.interface';

export const TabsDarkTheme: TabStyleType = {
  inkBarColor: ColorEnum.Teal150,
  itemActiveColor: ColorEnum.Teal100,
  itemHoverColor: ColorEnum.Teal100,
  itemSelectedColor: ColorEnum.Teal150,
};
